// extracted by mini-css-extract-plugin
export default {"contentLoaderRect":"Skeleton_contentLoaderRect__BaTZH","contentLoader":"Skeleton_contentLoader__HlSUb"};